import styled from 'styled-components/macro';
import { white } from '../../styles/colors';

export const Dropdown = styled.div`
  position: absolute;
  background: ${white};
  z-index: 99;
  width: 100%;
  max-height: ${({ small }) => (small ? '150px' : '220px')};
  overflow-y: auto;
  box-shadow: 1px 1px 1px 0 rgba(0, 0, 0, 0.1),
    4px 6px 7px 0 rgba(0, 0, 0, 0.14);

  &.dropup {
    bottom: 100%;
    top: auto;
    box-shadow: 1px -1px 1px 0 rgba(0, 0, 0, 0.1),
      4px -6px 7px 0px rgba(0, 0, 0, 0.14);
  }
`;
